export default __webpack_public_path__ + "static/media/svg-3.29e177ff.svg";